var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"inline-block"}},[_vm._v(_vm._s(this.countdown.days>0?this.countdown.days+"天":"")+_vm._s(this.countdown.hours)+":"+_vm._s(this.countdown.minutes)+":"+_vm._s(this.countdown.seconds))])}
var staticRenderFns = []

export { render, staticRenderFns }